import { render, staticRenderFns } from "./SyllablesTestAnswerOption.vue?vue&type=template&id=6724e0ab&scoped=true"
import script from "./SyllablesTestAnswerOption.vue?vue&type=script&lang=ts"
export * from "./SyllablesTestAnswerOption.vue?vue&type=script&lang=ts"
import style0 from "./SyllablesTestAnswerOption.vue?vue&type=style&index=0&id=6724e0ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6724e0ab",
  null
  
)

export default component.exports